/* global globalThis */

export const DEFAULT_ONETRUST_SCRIPT_ID = "01a1a067-7f87-70a3-a320-7b1cb9982f55-test";
const PROD_HOSTNAME = "dashboard.colliers.com";

export const getOneTrustScriptId = (
    rawId = process.env.REACT_APP_ONETRUST_SCRIPT_ID,
    hostname = globalThis.location?.hostname
) => {
    const configuredId = (rawId || DEFAULT_ONETRUST_SCRIPT_ID).trim();
    const baseId = configuredId.replace(/-test$/i, "");
    return hostname?.toLowerCase() === PROD_HOSTNAME ? baseId : `${baseId}-test`;
};

export const otRenderCookiePolicy = () => {
    const policyContainer = document.getElementById("ot-sdk-cookie-policy");
    if (policyContainer) {
        policyContainer.innerHTML = "";
        globalThis.OneTrust?.initializeCookiePolicyHtml?.();
    }
};

export const otOpenPreferenceCenter = () => {
    globalThis.OneTrust?.ToggleInfoDisplay?.();
};

export const otInjectCookieScript = (appId) => {
    if (document.getElementById("ot-sdk-stub-script-001")) {
        return;
    }

    const resolvedId = appId || getOneTrustScriptId();
    const otSDKStub = document.createElement("script");
    otSDKStub.id = "ot-sdk-stub-script-001";
    otSDKStub.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    otSDKStub.type = "text/javascript";
    otSDKStub.charset = "UTF-8";
    otSDKStub.setAttribute("data-document-language", "true");
    otSDKStub.setAttribute("data-domain-script", resolvedId);
    document.head.appendChild(otSDKStub);

    globalThis.OptanonWrapper = () => {
        otRenderCookiePolicy();
        globalThis.evaluateFullStoryConsent?.();
    };
};
